import { ShortBody, Captions } from 'components/Typography';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

export const StyledDropZoneContainer = styled(Grid)`
  &&&& {
    .MuiDropzoneArea-root {
      margin-bottom: 16px;
      min-height: 143px;
      border: 1px dashed rgba(0, 117, 201, 0.53);
      border-radius: 8px;
      padding: 25px 80px;
      &:hover {
        color: red;
      }
    }
    .MuiDropzonePreviewList-removeButton {
      background-color: #fafafb;
      box-shadow: none;
      color: #9ba0ad;
      opacity: 1;
      top: 20px;
      right: 12px;
    }
    .MuiDropzonePreviewList-imageContainer {
      text-align: left;
    }
    .MuiDropzoneArea-text {
      color: #9ea4b3;
      font-size: 14px;
      font-weight: 300;
    }
    .MuiDropzoneArea-icon {
      color: #cfd2da;
    }
  }
`;

export const ImageWrapper = styled(Grid)`
  background-color: #fafafb;
  border: 1px solid #f3f3f3;
  padding: 12px 24px;
  border-radius: 4px;
`;
export const StyledShortBody = styled(ShortBody)`
  && {
    margin-bottom: 6px;
  }
`;
export const StyledCaptions = styled(Captions)`
  && {
    margin-bottom: 0px;
  }
`;
